import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import {  catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { localStorageService } from './local-storage.service';
import { AuthService } from './auth.service';
import {   retry } from 'rxjs/operators';
import { ScrollbarHelper } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

interface ApiResponse {
  data: any;  // Define the type of 'data' based on your API response structure, e.g., `any[]` or a specific shape.
}

@Injectable({
  providedIn: 'root'
})

export class ApisService {
  apiUrl: string;

 
  
  // domain
  private domain = environment.productionDomain;

  
  DepartmentsAdd: any[] = [];
  password: any[] = [];
  email: any[] = [];


  constructor(private http: HttpClient,private router: Router, private authService: AuthService,
    private localStorage: localStorageService ,  private translate: TranslateService
  ) {}

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.status === 401) {
      const deviceId = this.authService.getCurrentDevice()?.id;
      this.authService.logout(deviceId);
      this.localStorage.clear();
      this.router.navigate(['/auth/login']); 
    }
    return throwError(error);
  }
  logout(): Observable<any> {
    return this.http.post<any>(this.domain + 'dashboard/logout', {});
  }
  company() {
    return this.http.post(this.domain + '/dashboard/companies',{});
  }
 

  requestAds():Observable<any> { 
    return this.http.post<any>(this.domain +'user-sliders',{});
  }

   employee():Observable<any> { 
      const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    return this.http.get<any>(this.domain +'/api/dashboard/employee',{headers});
  }
   contactUs():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/contact-us',{});
  }
  
   alerts():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/send-notification',{});
  }
  
   notifications():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/notifications',{});
  }

    getCities():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/cities',{});
  }
  

  pagesData():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/pages',{});
  }
  

  goals():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/pages/goals',{});
  }

  partners():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/partners',{});
  }
  addPartners(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });
  

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/partners',payload,
    { headers }
  );
}
editPartners(id: string, data: FormData): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  
   const url = `${this.domain}/api/dashboard/partners/${id}?_method=PUT`;
  return this.http.post<ApiResponse>(url, data, { headers });
}
getPartnerById(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/partners/${id}`,
    { headers }
  );
}
  

  vision():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/pages/vision',{});
  }
  

  aboutt():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/pages/about',{});
  }
  

  Faq():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/qommon-question',{});
  }
  

  // pagesData():Observable<any> { 
  //   return this.http.get<any>(this.domain +'/api/dashboard/pages',{});
  // }
  

  investors():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/investors',{});
  }
  

  flag():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/flag',{});
  }
  

  deleteAccount():Observable<any> { 
    return this.http.post<any>(this.domain +'/api/dashboard/flag',{});
  }
  

  privacy():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/pages/edit/privacy',{});
  }
  

  authPrivacy():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/pages/privacy',{});
  }
  

  Nterms():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/pages/edit/terms',{});
  }
  

  Nabout():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/pages/edit/about',{});
  }
  

  terms():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/pages/terms',{});
  }
  

  // contracts():Observable<any> { 
  //   const token = localStorage.getItem('userToken');
  //   const lang = localStorage.getItem('currentLang') || 'ar';
  // const headers = new HttpHeaders({
  //   Authorization: `Bearer ${token}`,
  //  'lang': lang,
  //    'Content-Type': 'application/json'
  // });
    
  //   return this.http.get<any>(this.domain +'/api/dashboard/contracts',{headers});
  // }
contracts(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/dashboard/contracts', { headers });
}
sectors(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/dashboard/sectors', { headers });
}
visionKsa(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/dashboard/vision', { headers });
}

teamMembers(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/dashboard/team-members', { headers });
}

ourMessage(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/pages/our-message', { headers });
}

reports(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/dashboard/reports', { headers });
}

news(page: number = 1): Observable<any> {

  const token = localStorage.getItem('userToken');
  const lang = localStorage.getItem('currentLang') || 'ar';

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept': 'application/json',
    'Accept-Language': lang,
    'lang': lang,
    'Content-Type': 'application/json'
  });

  return this.http.get<any>(
    `${this.domain}/api/dashboard/news?page=${page}`,
    { headers }
  );
}

newss(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + '/api/dashboard/news', { headers });
}
getPayments(id: any): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
        'Content-Type': 'application/json'
    });
    
    return this.http.get<any>(this.domain + `/api/dashboard/installments/${id}/details`, { headers });
}

addPayments(id: any, payload: any): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
    });
    
    return this.http.post<any>(this.domain + `/api/dashboard/installments/${id}/pay`,payload,{ headers });
}


paidPayments(): Observable<any> { 
    const token = localStorage.getItem('userToken');
    const lang = localStorage.getItem('currentLang') || 'ar';
    
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Accept-Language': lang, // استخدم هذا بدلاً من `lang`
        'lang': lang,
    });
    
    return this.http.get<any>(this.domain + `/api/dashboard/paid/installments`,{ headers });
}

  dashboard():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard',{});
  }
 
  searchInvestors(search: string) {
  return this.http.get<any>(this.domain +`/api/dashboard/investors?search=${encodeURIComponent(search)} ` );
}

  searchImployee(search: string) {
  return this.http.get<any>(this.domain +`/api/dashboard/employee?search=${encodeURIComponent(search)} ` );
}

  searchNotification(search: string) {
  return this.http.get<any>(this.domain +`/api/dashboard/users?search=${encodeURIComponent(search)} ` );
}



  contractsById(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');
 const lang = localStorage.getItem('currentLang') || 'ar';
  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'lang': lang,
     'Content-Type': 'application/json'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/contracts/${id}`,
    { headers }
  );
}
  

  contractsType():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/contracts-type',{});
  }
  
  

  Users():Observable<any> { 
    return this.http.get<any>(this.domain +'/api/dashboard/users',{});
  }
  

  // goals():Observable<any> { 
  //   return this.http.get<any>(this.domain +'/api/pages/goals',{});
  // }
  

  // vision():Observable<any> { 
  //   return this.http.get<any>(this.domain +'/api/pages/vision',{});
  // }


  // employee():Observable<any> { 
  //   return this.http.get<any>(this.domain +'/api/dashboard/employee',{});
  // }

  getJobTitles():Observable<any> { 
     const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang,
    'lang': lang
  });
    return this.http.get<any>(this.domain +'/api/dashboard/job-titles',{ headers });
  }
   getCountriesM():Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'lang': lang
    });
      return this.http.get<any>(this.domain +'/api/dashboard/countries',{ headers });
    }

     addCountriesM(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/countries',payload,
    { headers }
  );
}
getCitiesM():Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'lang': lang
    });
      return this.http.get<any>(this.domain +'/api/dashboard/cities',{ headers });
    }
getCitiesById(id:any):Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'lang': lang
    });
      return this.http.get<any>(this.domain +`/api/dashboard/cities/country/${id}`,{ headers });
    }
    getCityById(id:any):Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'lang': lang
    });
      return this.http.get<any>(this.domain +`/api/dashboard/cities/${id}`,{ headers });
    }
     addCitiesM(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/cities',payload,
    { headers }
  );
}
   getContractOne():Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
     'Accept-Language': lang,
    'lang': lang
  });
    return this.http.get<any>(this.domain +'/api/dashboard/home/contracts/installments',{ headers });
  }


  
addPaidInstallmentsContract(id:any, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + `/api/dashboard/installments/${id}`,
    payload,
    { headers }
  );
}

addMultiPaidInstallments(payload: any): Observable<ApiResponse> {

  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + `/api/dashboard/installments/pay`,
    payload,
    { headers }
  );
}

  getchatData():Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
     'Accept-Language': lang,
    'lang': lang
  });
    return this.http.get<any>(this.domain +'/api/dashboard/chat',{ headers });
  }
   getChatAnalysis():Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
     'Accept-Language': lang,
    'lang': lang
  });
    return this.http.get<any>(this.domain +'/api/dashboard/chat/stats',{ headers });
  }
  getchatDataById(id: string): Observable<ApiResponse> {
   const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });
  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/chat/${id}/messages`,
    { headers }
  );
}
  Deleteinvestors(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/investors/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteContractstype(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/contracts-type/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteNotifications(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/notifications/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteContracts(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/contracts/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  endContract(id: any): Observable<any> {
    const token = this.authService.getAuthToken();
    const lang = this.translate.currentLang;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept-Language': lang,
      'lang': lang
    });

    return this.http.post<any>(
      `${this.domain}/api/dashboard/contracts/${id}/cancel`,
      {},
      { headers }
    ).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  DeleteSectors(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/sectors/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteVisionKsa(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/vision/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteTeamMembers(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/team-members/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteReports(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/reports/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

  DeleteNews(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/news/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}


DeletePartners(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/partners/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}


  DeleteEmployee(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });
  

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/employee/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}


  DeleteFaq(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });
  

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/qommon-question/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}



  DeleteJobTitles(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });
  

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/job-titles/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}


  DeleteCities(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'Accept-Language': lang
  });
  

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/cities/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

editCity(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');
  const lang = this.translate.currentLang;

  // إذا كان payload هو FormData، لا تضبط Content-Type (سيضبطه المتصفح تلقائياً)
  let headers: HttpHeaders;
  
  if (payload instanceof FormData) {
    headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Accept-Language': 'en',
      'lang': lang
      // لا تضبط Content-Type لـ FormData
    });
  } else {
    // إذا كان JSON، اضبط Content-Type
    headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Accept-Language': 'en',
      'lang': lang,
      'Content-Type': 'application/json'
    });
  }

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/cities/${id}`,
    payload,
    { headers }
  );
}
getCountriesById(id:any):Observable<any> { 
     const token = this.authService.getAuthToken();
     const lang = this.translate.currentLang;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'lang': lang
    });
      return this.http.get<any>(this.domain +`/api/dashboard/countries/${id}`,{ headers });
    }
// editCountries(id: string, payload: any): Observable<ApiResponse> {
//   const token = localStorage.getItem('userToken');
//   const lang = this.translate.currentLang;

//   const headers = new HttpHeaders({
//     Authorization: `Bearer ${token}`,
//     'Accept-Language': 'en',
//     'lang': lang,
//     'Content-Type': 'application/json' // ✅ ensure JSON type
//   });

//   return this.http.put<ApiResponse>(
//     `${this.domain}/api/dashboard/countries/${id}`,
//     payload,
//     { headers }
//   );
// }
  // أو بدلاً من HttpParams يمكن استخدام object عادي
  editCountriesMSimple(id: string, data: any): Observable<any> {
    const url = `api/dashboard/countries/${id}`;
    
    console.log('Full URL:', `${url}?name_en=${data.name_en}&name_ar=${encodeURIComponent(data.name_ar)}`);
    
    return this.http.put(url, {}, { 
      params: {
        name_en: data.name_en,
        name_ar: data.name_ar
      }
    });
  }
  editCountries(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'lang': lang,
    'Content-Type': 'application/json' // ✅ ensure JSON type
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/countries/${id}`,
    payload,
    { headers }
  );
}

  //  editCountriesM(id: string, data: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json'
  //   });

  //   console.log('Sending PUT request to:', `api/dashboard/countries/${id}`);
  //   console.log('Request data:', data);
    
  //   return this.http.post(`api/dashboard/countries/${id}`, data, { headers });
  // }

  // أو إذا كنت تريد استخدام FormData
  editCountriesM(id: string, data: any): Observable<any> {
    const formData = new FormData();
    formData.append('name_en', data.name_en);
    formData.append('name_ar', data.name_ar);

    console.log('Sending FormData:');
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });

    return this.http.post(`api/dashboard/countries/${id}`, formData);
  }
  DeleteCity(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });
  

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/cities/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
 DeleteCountries(id:any): Observable<any> { 
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });
  

  return this.http.delete<any>(
    `${this.domain}/api/dashboard/countries/${id}`,
    { headers }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}

 addInvestor(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/investors',payload,
    { headers }
  );
}
  

addPaidAmount(id:any, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + `/api/dashboard/installments/${id}/pay`,
    payload,
    { headers }
  );
}
  

addPaidInstallments(id:any, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + `/api/dashboard/installments/${id}`,
    payload,
    { headers }
  );
}


 addContracts_type(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/contracts-type',payload,
    { headers }
  );
}
  


 addContracts(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/contracts',payload,
    { headers }
  );
}
  


 addSectors(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/sectors',payload,
    { headers }
  );
}
  


 addVision(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/vision',payload,
    { headers }
  );
}
  

 addTeamMembers(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/team-members',payload,
    { headers }
  );
}
  

 addOurMessages(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/pages/our-message',payload,
    { headers }
  );
}
  

 addReports(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/reports',payload,
    { headers }
  );
}
  


 addnews(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/news',payload,
    { headers }
  );
}
  


 addFaq(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/qommon-question',payload,
    { headers }
  );
}
  


 addFaqs(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/qommon-question',payload,
    { headers }
  );
}
  



 addEmployee(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/employee',payload,
    { headers }
  );
}


 updateVision(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/employee',payload,
    { headers }
  );
}


 updateGoals(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/employee',payload,
    { headers }
  );
}


 updateGoalss(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    this.domain + '/api/dashboard/pages/goals',payload,
    { headers }
  );
}


 updateAboutt(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    this.domain + '/api/dashboard/pages/about',payload,
    { headers }
  );
}



 addAlerts(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/send-notification',payload,
    { headers }
  );
}




   addJobTitles(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + '/api/dashboard/job-titles',payload,
    { headers }
  );
}



getInvestorById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/investors/${id}`,
    { headers }
  );
}


getContractstypeById(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/contracts-type/${id}`,
    { headers }
  );
}



getContractsById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/contracts/${id}`,
    { headers }
  );
}


getSectorsById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/sectors/${id}`,
    { headers }
  );
}

getVisionKsaById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/vision/${id}`,
    { headers }
  );
}

getTeamMembersById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/team-members/${id}`,
    { headers }
  );
}

getReportsById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/reports/${id}`,
    { headers }
  );
}


getNewsById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/news/${id}`,
    { headers }
  );
}


getRelatedNewssById(id: string): Observable<ApiResponse> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/news/${id}/related`,
    { headers }
  );
}
getRelatedNewsById(newsId: string, news_ids: number[]): Observable<any> {
  const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  // Must send body as { news_ids: [1,2,3] }
  const body = { news_ids };

  return this.http.post(
    `${this.domain}/api/dashboard/news/${newsId}/related`,
    body,
    { headers }
  );
}



getFaqById(id: string): Observable<ApiResponse> {
   const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/qommon-question/${id}`,
    { headers }
  );
}



getEmployeeById(id: string): Observable<ApiResponse> {
   const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });
  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/employee/${id}`,
    { headers }
  );
}


getNotificationsById(id: string): Observable<ApiResponse> {
   const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });
  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/notifications/${id}`,
    { headers }
  );
}


getContactUsById(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/contact-us/${id}`,
    { headers }
  );
}
getJobTitleById(id: string): Observable<ApiResponse> {
 const token = this.authService.getAuthToken();
  const lang = this.translate.currentLang;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`,
    'lang': lang
  });

  return this.http.get<ApiResponse>(
    `${this.domain}/api/dashboard/job-titles/${id}`,
    { headers }
  );
}


editInvestor(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  // const headers = new HttpHeaders({
  //   Authorization: `Bearer ${token}`,
  //   'Accept-Language': 'en'
  // });

  // return this.http.put<ApiResponse>(
  //   `${this.domain}/api/dashboard/investors/${id}`,
  //   payload,
  //   { headers }
  // );
  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    // ❌ Do NOT set 'Content-Type' manually when using FormData
    'Accept-Language': 'en'
  });

  const url = `${this.domain}/api/dashboard/investors/${id}?_method=PUT`;

  // ✅ Send the FormData directly in the body
  return this.http.post<ApiResponse>(url, payload, { headers });
}



editAbout(params: HttpParams): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/pages/about`,
    {}, // no body
    { headers, params }
  );
}


editPrivacy(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}


editAuthPrivacy(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/privacy/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}



editNterms(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}



editOurmessage(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}



editNabout(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}

editNaboutVisions(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/about/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}

editNaboutGoals(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/goals/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}


editNabouttt(data: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/pages/edit/about/${data.id}`, 
    {
      title_ar: data.title_ar,
      title_en: data.title_en,
      content_ar: data.content_ar,
      content_en: data.content_en
    },
    { headers }
  );
}



editTerms(params: HttpParams): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/pages/terms`,
    {}, // no body
    { headers, params }
  );
}



editContractstType(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json' // ✅ ensure JSON type
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/contracts-type/${id}`,
    payload,
    { headers }
  );
}


editContracts(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/contracts/${id}`,
    payload,
    { headers }
  );
}

editSectors(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/sectors/${id}`,
    payload,
    { headers }
  );
}

editVisionsKsa(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/vision/${id}`,
    payload,
    { headers }
  );
}


editTeamMembers(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/team-members/${id}`,
    payload,
    { headers }
  );
}


editReports(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/reports/${id}`,
    payload,
    { headers }
  );
}


editNews(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/news/${id}`,
    payload,
    { headers }
  );
}

editContactUs(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}/api/dashboard/contact-us/${id}/status`,
    payload,
    { headers }
  );
}


// editFaq(id: string, payload: any): Observable<ApiResponse> {
//   const token = localStorage.getItem('userToken');

//   const headers = new HttpHeaders({
//     Authorization: `Bearer ${token}`,
//     'Accept-Language': 'en'
//   });

//   return this.http.put<ApiResponse>(
//     `${this.domain}/api/dashboard/qommon-question/${id}`,
//     payload,
//     { headers }
//   );
// }

editFaq(
  id: string,
  question_ar: string,
  question_en: string,
  answer_ar: string,
  answer_en: string
): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
    'Content-Type': 'application/json'
  });

  const body = {
    question_ar,
    question_en,
    answer_ar,
    answer_en
  };

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/qommon-question/${id}`,
    body,
    { headers }
  );
}


// editEmployee(id: string, payload: any): Observable<ApiResponse> {
//   const token = localStorage.getItem('userToken');

//   const headers = new HttpHeaders({
//     Authorization: `Bearer ${token}`,
//     'Accept-Language': 'en'
//   });

//   return this.http.put<ApiResponse>(
//     `${this.domain}/api/dashboard/employee/${id}`,
//     payload,
//     { headers }
//   );
// }

editEmployee(id: string, data: FormData): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    // ❌ Do NOT set 'Content-Type' manually when using FormData
    'Accept-Language': 'en'
  });

  const url = `${this.domain}/api/dashboard/employee/${id}?_method=PUT`;

  // ✅ Send the FormData directly in the body
  return this.http.post<ApiResponse>(url, data, { headers });
}


editJobTitle(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('userToken');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}/api/dashboard/job-titles/${id}?${payload}`,
    
    { headers }
  );
}



  // levels(): Observable<any> {
  //   return this.authenticatedGet(
  //     `${this.domain}/api/dashboard-auth-api/levels`
  //   );
  // }

  // article() {
  //   return this.http.post(this.domain + '/articles',{});
  // }
 
  article(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'articles', {});
  }
  
 
  about(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'about-app', {});
  }
 
  getCountry(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'countries', {});
  }
 
  LoginOtp(data: any, token: any): Observable<any> {
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${this.domain}user/active-profile`, data, { headers: header });
  }
  completeProfile(token: any, data: any) {
    return this.http.post(`${this.domain}user/update-profile`, data, { headers: new HttpHeaders().set('Authorization', `Bearer ${token}`) });
  }
  // countries(): Observable<ApiResponse> {
  //   return this.http.post<ApiResponse>(this.domain + 'countries', {});
  // }
 
  ganatakCommunity(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'community-posts', {});
  }

  plantCards(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'user/make-order', {});
  }
  
 
  store(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'active-store-products', {});
  }
  users(): Observable<any> {
    return this.http.post<any>(this.domain + 'user/login', {});
  }
  
  companies(service_id: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'service-companies', {service_id: service_id});
  }
  //Consulting List
  requestConsultations() : Observable<ApiResponse> {
    //waiting for the token
    // const Authorization = '1myQSGIIuD22gI3iruJXWOILoysWAOtF02y1P7XX' 
    // const httpheaders :HttpHeaders = new HttpHeaders ().set(
    //   'Authorization' , `Bearer ${Authorization}`
    // )
    return this.http.post<ApiResponse>(this.domain+ 'user/user-consultants', {} )
  }
 //edit consultation
  requestConsultationDetail(consulting_id : any): Observable<ApiResponse>{ 
    return this.http.post<ApiResponse>(this.domain+ 'user/make-consultant' ,{consulting_id:consulting_id} )
  }
  //make consultation
  requestConsultationBook() : Observable<ApiResponse> {  
    const headers = HttpHeaders
    return this.http.post<ApiResponse>(this.domain+'user/consultant-details',{})
  }
  
  requestTerms(): Observable<ApiResponse> { 
    return this.http.post<ApiResponse>(this.domain+'terms-app' , {})
  }

  requestTagArticles(tag_id :any) : Observable<ApiResponse> { 
    //authorization needed
    
    return this.http.post<ApiResponse>(this.domain+'tag-articles',{tag_id:tag_id})
  }

  requestTagProducts(tag_id:any):Observable<ApiResponse>{
    //authorization needed 
    return this.http.post<ApiResponse>(this.domain+'tag-products',{tag_id:tag_id})
  }

  requestNotificationsCount():Observable<ApiResponse>{
    //authorization needed 
    return this.http.post<ApiResponse>(this.domain+'user-notifications-count',{})
  }

  requestNotifications(page:any):Observable<ApiResponse>{
    //authorization needed  
    return this.http.post<ApiResponse>(this.domain+'user-notifications',{page:page})
  }

  requestNotificationSee(notification_id:any):Observable<ApiResponse>{
    //authorization needed  
    return this.http.post<ApiResponse>(this.domain+'user-seen-notifications',{notification_id:notification_id})
  }

  requestServiceCategories():Observable<ApiResponse> { 
    return this.http.post<ApiResponse>(this.domain+'services' ,{})

  }

  requestServiceSubCategories():Observable<ApiResponse>{ 
    return this.http.post<ApiResponse>(this.domain+'sub-services',{})
  }

  requestOffers(page:number , category_id:string , discount_sort:string ,keyword:string):Observable<ApiResponse>{ 
    return this.http.post<ApiResponse>(this.domain+'search-offers',
      {page:page , category_id:category_id , discount_sort:discount_sort , keyword:keyword})
  }
requestHomeOffers():Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'home-products',{})
}

requestCategoryOffers(category_id:number):Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'category-offer',{category_id:category_id})
}

requestCancelReasons():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'user/cancelOrderReasons',{})
}
requestCancelOrder(order_id:number , cancellation_reason_id:number ):Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'user/cancelOrder', 
    {order_id:order_id , cancellation_reason_id:cancellation_reason_id})
}
requestMarketCategories():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'categories-list',{})
}

requestShops():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'category-stores',{})
}
requestShopProductsCategories(shop_id:number):Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'store-id-categories',{shop_id:shop_id})
}

requestShopProducts():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'store-category-id-products',{})
}
requestProducts():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'category-store-id-products',{})
}
requestArticleCategories():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'articles-categories-list' ,{})
}

  // companyRate(companyId: any): Observable<any> {
  //   return this.http.post(`${this.domain}/dashboard/company-rates`, { companyId: companyId });
  // }

 
  // Login(email: any, password: any) {
  //       const headers = new HttpHeaders().set('Content-Type', 'application/json');

  //   return this.http.post('https://qaiim.newegyptgroup.com/api/dashboard/admin-login', { email, password }, {headers});
  // }
 

  // removeDepartment(departmentId: any): Observable<any> {
  //   return this.http.post(`${this.domain}/dashboard/remove-department`,{departmentId});
  // }
  

  getLogin(data:any): Observable<any> {
    const url = `${this.domain}user/login`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .post(url, data, { headers })
      .pipe(catchError(this.handleError));
  }
} 

